import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import Team from "marketplace/teams/team";
import { z } from "zod";

export type MarketplaceTeamAPIRequestJSON = z.infer<
  typeof MarketplaceTeamAPIRequestSchema.MarketplaceTeamAPIRequestZ
>;

export default class MarketplaceTeamAPIRequestSchema {
  public static readonly MarketplaceTeamAPIRequestZ = z.object({
    isVisible: z.boolean().optional(),
    name: z.string(),
    description: z.string().optional(),
    categories: z.array(z.string()).optional(),
  });

  public static validateJSON(json: unknown): MarketplaceTeamAPIRequestJSON {
    return parseOrThrow(MarketplaceTeamAPIRequestSchema.MarketplaceTeamAPIRequestZ, json, {
      logError: true,
      schemaName: "MarketplaceTeamAPIRequestSchema",
      operation: "validateJSON",
      payloadSample: json,
    });
  }

  public static isValidJSON(json: unknown): json is MarketplaceTeamAPIRequestJSON {
    return MarketplaceTeamAPIRequestSchema.MarketplaceTeamAPIRequestZ.safeParse(json).success;
  }

  public static serialize(team: Team): MarketplaceTeamAPIRequestJSON {
    return MarketplaceTeamAPIRequestSchema.validateJSON({
      isVisible: team.isVisible,
      name: team.profile.name,
      description: team.profile.description,
      categories: team.profile.categories ?? [],
    });
  }
}
